import React, {Fragment, useState } from 'react';

import { connect } from 'react-redux';
import { DatePickerField, GridLoader, FormButton, FormButtonsWrap, FormHeading, ErrorsBlock, IconWrap, LoaderWrap } from '..';
import { Grid } from 'react-awesome-spinners';
import { pushMessage, updateAccountFromAuthToken } from '../../actions';
import { Ring } from 'react-awesome-spinners';
import { AUTHORIZE, CREATE_REQUESTDATE, delegatesForManager, delegationListWithSearch, requestdateListWithSearch, delegateRolesWithPers } from '../../graphql';
import { useQuery, useMutation, useLazyQuery } from '@apollo/react-hooks';
//import Select from 'react-select';
import "react-datepicker/dist/react-datepicker.css";
import { convertToUTC } from '../../util/helper';
import ApolloClient from 'apollo-boost';
import { authProvider } from '../../util/auth';

//import SearchItemsList from "./SearchItemsList";

//import Autocomplete from "./Autocomplete"; 

import createStore from '../../store';
import MyDelegates from '../../pages/MyDelegates';
import { parseType } from 'graphql';



const UpdateEffectiveDate = props => {
  const { account, hideModal, pushMessage } = props;
  const {pers_no, roles} = account;
  console.log("account===>", account);
  const isGct = roles.includes('gct')

  /*  RENEW NEW TOKEN AGAIN STARTS  */
  const extractMSALToken = function()
  {
    const timestamp = Math.floor((new Date()).getTime() / 1000)
    let token = null
  
    for (const key of Object.keys(sessionStorage)){
      if (key.includes('"authority":')){
        const val = JSON.parse(sessionStorage.getItem(key))
        if (val.expiresIn){
          // We have a (possibly expired) token
          if (val.expiresIn > timestamp && val.idToken === val.accessToken){
            // Found the correct token
            token = val.idToken
          }
          else{
            // Clear old data
            sessionStorage.removeItem(key)
          }
        }
      }
    }
    if (token) return token
    throw new Error('No valid token found')
  }
  const store = createStore();
  let accessPayload = sessionStorage.getItem('access_token_payload')
  if (accessPayload) {
    //console.log('accessPayload')
    store.dispatch(updateAccountFromAuthToken(JSON.parse(accessPayload)));
  }
  const acquireInternalToken = async function(externalToken)
  {
    if( !acquireInternalToken.promise ){
      acquireInternalToken.promise = new Promise((resolve, reject)=>{
        //console.log('Hi')
        client.query({query: AUTHORIZE, fetchPolicy: "no-cache"}).then((result)=>{
          //console.log(result)
          //console.log('Hi')
          
          sessionStorage.setItem('access_token', result.data.authorize.token)
          if (!accessPayload) {
            sessionStorage.setItem('access_token_payload', JSON.stringify(result.data.authorize.payload))
            store.dispatch(updateAccountFromAuthToken(result.data.authorize.payload));
          }
          resolve( result.data.authorize.token );
        }).catch((error)=>{
          console.log("ERROR acquiring access token")
          console.log(error.message)
          reject(error);
        });
      });
    }
    //console.log('Hello')
    //console.log(await acquireInternalToken.promise)
    return acquireInternalToken.promise
  }
  const client = new ApolloClient({
    uri: process.env.REACT_APP_GRAPHQL_API,
    request: async (operation) => {
      await authProvider.getAccessToken();
      const adIdToken = await authProvider.getIdToken();
      //console.log(adIdToken);

      let externalToken = sessionStorage.getItem('msal.idtoken')
      // If msal.istoken is not found, then we can extract it from the authority
      if(!externalToken){
        externalToken = extractMSALToken()
      }
      if( externalToken !== adIdToken.idToken.rawIdToken ){
        // External token renewed, need to renew internal as well
        delete acquireInternalToken.promise;
        sessionStorage.removeItem('access_token');
      }

      let internalToken = sessionStorage.getItem('access_token')
      if( externalToken && !internalToken && operation.operationName !== "Authorize" ){
        // Exchange external token to internal token
        internalToken = await acquireInternalToken( externalToken )
      }
      if( internalToken ){
        operation.setContext({
          headers: {
            authorization: `Bearer ${internalToken}`
          }
        })
      }
      else if( externalToken ){
        operation.setContext({
          headers: {
            authorization: `Bearer ${externalToken}`
          }
        })
      }
    },
    onError: ({ graphQLErrors, networkError, operation, forward }) => {
      //console.log(graphQLErrors);
      if (graphQLErrors) {
        
      }
    }
  });
  /*  RENEW NEW TOKEN AGAIN ENDS  */
  

  const now = new Date();

  /*  START DATE  */
   
  const startMonth = now;
  const [startDate, setStartDate] = useState(startMonth);
  const handleStartDateChange = date => setStartDate(date);
  
  /*  END DATE  */
  var oneYearFromNow = new Date();
  oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
  //console.log(oneYearFromNow)  
  const nextYear = oneYearFromNow;
  const [endDate, setEndDate] = useState(startMonth);
  const handleEndDateChange = date => setEndDate(date);




  
  const handleQuit = event => { hideModal(); 
    
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      width: 'state.selectProps.width',
      borderBottom: '1px dotted pink',
      color: state.selectProps.menuColor,
      padding: 10,
    }),
  }
  let inputText = '';
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitErrors, setSubmitErrors] = useState([]);
  const [createRequestDate] = useMutation(CREATE_REQUESTDATE);
  const handleCreateRequest = async event => {
    setIsSubmitting(true);
    setSubmitErrors([]);  

    
var selectedAssigneeText='';
var selectedAssigneeValue = '';
    if(document.getElementById("frmAssigneeSingle"))
    {
    var selectedAssigneeText = document.getElementById("frmAssigneeSingle").value;
    var selectedAssigneeValue = document.getElementById("frmStartDate").value;
    
    }
   

    if (selectedAssigneeText == '')
    {
      setSubmitErrors(['Request ID is required!']);
      setIsSubmitting(false);
      return null;
    }
    if (selectedAssigneeValue == '')
    {
      setSubmitErrors(['New Effective Date is required!']);
      setIsSubmitting(false);
      return null;
    }
     if(document.getElementById("frmRoles1"))
    {
          var frmRoles1 = document.getElementById("frmRoles1").value;
    }else{
       setSubmitErrors(['Invalid Valid Request ID!']);
       setIsSubmitting(false);
       return null;

    }  

    if(document.getElementById("frmStartDate"))
    {
      var frmStartDate = document.getElementById("frmStartDate").value;
      console.log(frmStartDate);
      var patternStartDate =/^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
      if(!patternStartDate)
      {
        setSubmitErrors(['Start Date is not valid!']);
        setIsSubmitting(false);
        return false;
      }
    }

 

    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth()+1; 
    var yyyy = today.getFullYear();
    //console.log(dd+'<====>'+mm+'<====>'+yyyy)
    var currentDateFormated = new Date(mm+'/'+dd+'/'+yyyy);

    var expDate = frmStartDate.split("/");
    var dd_1 = expDate[1];
    var mm_1 = expDate[0]; 
    var yyyy_1 = expDate[2];
    console.log(dd_1+'<====>'+mm_1+'<====>'+yyyy_1)
    var startDateFormated = new Date(mm_1+'/'+dd_1+'/'+yyyy_1);
    var newEffectiveDateFormated = yyyy_1+'-'+mm_1+'-'+dd_1;
    //var newEffectiveDateFormated = mm_1+'-'+dd_1+'-'+yyyy_1;

  var expDate_2 = frmRoles1.split("/");
    var dd_2 = expDate_2[0];
    var mm_2 = expDate_2[1]; 
    var yyyy_2 = expDate_2[2];
    console.log(dd_2+'<====>'+mm_2+'<====>'+yyyy_2)
    var newRolesDateFormated = yyyy_2+'-'+mm_2+'-'+dd_2;
    //var newRolesDateFormated = '2026-03-11';

    
    let insertedIds = [];
    let foundedError = [];
    let errorDuringProcess = '';
    let isActive = 0;

    var d1 = Date.parse(currentDateFormated);
    var d2 = Date.parse(frmStartDate);
    if (d2 == d1)
    {
      isActive = 1;
    }


    var checkedValue = null; 
    var inputElements = document.getElementsByName('frmRoles');
    for(var i=0; inputElements[i]; ++i){
          if(inputElements[i].checked){
              checkedValue = inputElements[i].value;
              break;
          }
    }

    
    for(var i=0; inputElements[i]; ++i)
    {
      if(inputElements[i].checked)
      {
        var selectedValue = inputElements[i].value;
        console.log(selectedValue);

        try {
          
          const results = await createRequestDate({
            variables: {
              data: {
                Request_id: selectedAssigneeText, 
                EFFECTIVE_DATE: newEffectiveDateFormated, 
                EFFECTIVE_CHANGE_DATE: newRolesDateFormated,
                Updated_by:account.last_name+', '+account.first_name,
                Action_date:new Date(),
              }
            },
            
          });
          //console.log(results, "RESULTS+++++++++>>>>>>>>");
          if(results)
          {
           
          }
        }
        catch(e) {
          //console.log(e)
          //console.log(e.message)
          if(e.message != '')
          {
            var roleFullName = '';
            
           errorDuringProcess = 'Yes';
            foundedError[i] = {'for_role' :roleFullName, 'message' : e.message};
            
          }
          //console.log(results);
        } 
        //console.log(results);return null;
        if(errorDuringProcess == 'Yes')
        {
          //break;
        }
      }
    }
    //console.log("ERROR DURING PROCESS===>"+errorDuringProcess)
   if(errorDuringProcess == '' && foundedError.length == 0)
    {
      hideModal();
      //setTimeout(() => {window.location.reload();}, 1);
      pushMessage({
        type: 'success',
        message: 'Effective Date has been Change successfully!'
      })
      
    }
    else
    {
      
    }
    
  };
  
  const state = {
    item: {
      name: ""
    },
    cursor: 0,
    searchItems: [],
    myTestResult:[]
  };
  const [setKeyPressed] = useState([]);

  const hanldeKeyup = (evt) => {
    if (evt.keyCode === 27) {
      setKeyPressed({ searchItems: [] });
      return false;
    }
  }
  const hanldeKeydown = (evt) =>
  {
    //console.log(evt.keyCode);
    if (evt.keyCode === 38 && cursor > 0) 
    {
      setKeyPressed(prevState => ({
        cursor: prevState.cursor - 1
      }));
    } 
    else if (evt.keyCode === 40 && cursor < searchItems.length - 1) 
    {
      setKeyPressed(prevState => ({
        cursor: prevState.cursor + 1
      }));
    }
    if (evt.keyCode === 13) 
    {
      let currentItem = searchItems[cursor];
      if (currentItem !== undefined) {
        const { name } = currentItem;
        setKeyPressed({ item: { name }, searchItems: [] });
      }
    }
    if (evt.keyCode === 8) 
    {
      //setKeyPressed({ item: { name: "" } });
    }
  }
  const selectItem = (id) => 
  {
    const { searchItems } = state;
    let selectedItem = searchItems.find(item => item.code === id);
    const { name } = selectedItem;
    setKeyPressed({ item: { name }, searchItems: [] });
  }

  const { searchItems, cursor, item } = state;
  const { name } = item;
  const [searchTxtValue, setSearchTxtValue] = useState('');
  
  const _executeSecondSearch = async (evt) => {
    inputText = evt.target.value;
    inputText = inputText.trim();
    //console.log(inputText);
    setSearchTxtValue(inputText);
    
    /*  QUERY FIRE FOR FETCHING RECORDS WITH ENTERED KEYWORD STARTS  */
    var lengthOfInputText = inputText.length;
    //document.getElementById('frmAssigneeSingle_Selected').value = '';
    if(lengthOfInputText >= 3)
    {
      var reg = new RegExp('^[0-9]+$');
      if(reg.test(inputText) === true)  /*  IF TEXT IS NUMBER   */
      {
        var nokiaID = inputText;
        console.log(nokiaID);
        var fullName = '';
      }
      else
      {
        var nokiaID = '';
        var fullName = inputText;
      }
    
      document.getElementById('frmLoader_Roles').style.display = 'block';
      document.getElementById('frmRolesPanel').style.display = 'none';
      document.getElementById('frmRolesPanel').innerHTML = '&nbsp;';
      const where_1 = { nokia_id: nokiaID, full_name: fullName };
      const delegateSearchResult = await client.query({
        query: requestdateListWithSearch,
        variables: { where: where_1, limit : 500 } ,
      })  
      console.log(delegateSearchResult);
      if(delegateSearchResult)
      {
        if(delegateSearchResult.data.requestdateList.items && delegateSearchResult.data.requestdateList.items.length > 0)
        {
          var date1=null;
          if(delegateSearchResult.data.requestdateList.items[0].request_type=='onetime')
          {
            date1 = new Date(parseInt(delegateSearchResult.data.requestdateList.items[0].payment_date));
          }
          else
          {
            date1 = new Date(parseInt(delegateSearchResult.data.requestdateList.items[0].effective_date));
          }
          //const date1 = new Date(parseInt(delegateSearchResult.data.requestdateList.items[0].effective_date));
          console.log("Orginal Date===>"+date1);
          var result_NokiaID = date1.toLocaleString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric'});
          console.log("Original Date Formateed=>>>"+result_NokiaID);

          var originalDateFormatToDisplay = date1.toLocaleDateString('en-IN', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          });
          console.log("Original Date To View=>>>"+originalDateFormatToDisplay);
        
          //var result_FullName = delegateSearchResult.data.delegationList.items.full_name;
         var resultStr = '';
          resultStr += '<span style="float:left; width:100%; margin:1% 0 1% 0">';
           resultStr += '<span style="float:left; width:100%; margin:1% 0 1% 0">';
                resultStr += '<span style="float:left; width:50%"><b style="font-size=13px;font-weight: bold;">Current Effective Date:&nbsp;&nbsp;';
                  resultStr +=originalDateFormatToDisplay+'<input type="hidden" name="frmRoles" id="frmRoles1"  checked="1" readonly value=\''+result_NokiaID+'\';';
                resultStr += '</b></span>';
                resultStr += '<span style="float:left; width:80%; color:#000">';
                  resultStr += '';
                resultStr += '</span>';
              resultStr += '</span>';
             resultStr += '</span>'; 

         // if(bolAnyRoleExists == false)
          //{
          //  resultStr += '<span style="float:left; width:100%; margin:1% 0 1% 0;background-color: moccasin;font-weight: bold;padding: 0 1%;">Sorry! You do not have sufficient roles to create the delegate.';
              
          //  resultStr += '</span>';
          //}
          document.getElementById('frmLoader_Roles').style.display = 'none';
          document.getElementById('frmRolesPanel').style.display = 'block';
          document.getElementById('frmRolesPanel').innerHTML = resultStr;
          document.getElementById('frmLoader').style.display = 'none';
        }
        else
        {
          document.getElementById('frmLoader_Roles').style.display = 'none';
          document.getElementById('frmRolesPanel').style.display = 'block';
          document.getElementById('frmRolesPanel').innerHTML = '<b style="font-size=13px;font-weight: bold;">Invalid request ID</b>';
          document.getElementById('frmLoader').style.display = 'none';
          
        }
      }
    }
    /*  QUERY FIRE FOR FETCHING RECORDS WITH ENTERED KEYWORD ENDS  */
    
  }
  return (
    <div style={{height:'500px'}}>  {/* added height for delagete model UI chnages */}
      <FormHeading> Effective Date Change</FormHeading>
      <Fragment>
        <div style={{width:'80%', width:'100%', border:'0px solid', margin: '3% 0 0 0'}}>
          <div style={{width:'100%', border:'0px solid'}}>
            <span style={{float:'left', width:'10%'}}><b>Request ID:</b></span>
            <span style={{float:'left', width:'35%'}}>
            <input type="hidden" name="frmAssigneeSingle_Selected" id="frmAssigneeSingle_Selected" style={{width:'100%', border:'1px solid #000', 'line-height':'35px'}}  />
              <input type="text" name="frmAssigneeSingle" id="frmAssigneeSingle" 
              placeholder="Type Request ID to get current Effective date" style={{width:'100%', border:'1px solid #000', 'line-height':'35px'}} 
              //disabled={!bolAnyRoleExists}
              onKeyDown={hanldeKeydown} 
              onKeyUp={hanldeKeyup} 
              onChange={_executeSecondSearch} 
              //onFocus={_executeSecondSearch}
              />
              <input type="hidden" name="aaaaa" id="aaaaa" value=""  style={{width:'100%', border:'1px solid #000', 'line-height':'35px'}} />
              <span style={{float:'left', width:'100%', border: '1px solid', 'min-height': '22px', 'max-height': '140px', position: 'relative', overflow: 'auto', display: 'none'}} id="searchResult">&nbsp;</span>
              {/*[<i style={{color:'#000'}}>Type Nokia ID/Name to get the list.</i>]*/}
            </span>
            <span id="frmLoader" style={{float:'left', width:'3%', 'margin-left':'1%', display: 'none'}}><img src="./animated-ajax-1.gif" /></span>
          </div>
          <div style={{width:'100%', float:'left', border:'0px solid'}}>&nbsp;</div>
          
         
          <div style={{width:'100%', float:'left', border:'0px solid'}}>&nbsp;</div>

          <div style={{width:'100%', width:'100%', border:'0px solid'}}>
            <span style={{float:'left', width:'10%'}}><b width="10%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b></span>
            <span style={{float:'left', width:'60%', display: 'block'}} id="frmRolesPanel"></span>
            <span id="frmLoader_Roles" style={{float:'left', width:'3%', 'margin-left':'1%', display: 'none'}}><img src="./animated-ajax-1.gif" /></span>
          </div>
          <div style={{width:'100%', float:'left', border:'0px solid'}}>&nbsp;</div>

          <div style={{width:'100%', float:'left', border:'0px solid'}}>
            <span style={{float:'left', width:'10%'}}><b>New Effective Date:</b></span>
            <span style={{float:'left', width:'60%'}}>
              {/*<DatePickerField id="frmStartDate"  selected={startDate} onChange={handleStartDateChange} minDate={startMonth} maxDate={nextYear}  />*/}
              <DatePickerField id="frmStartDate"  selected={startDate} onChange={handleStartDateChange}  />
            </span>
          </div>
          
          <div style={{width:'100%', float:'left', border:'0px solid'}}>&nbsp;</div>

          <div style={{width:'100%', float:'left', border:'0px solid'}}>
            <span style={{float:'left', width:'10%'}}>&nbsp;</span>
            <span style={{float:'left', width:'60%'}}>
              <FormButtonsWrap>
                <FormButton onClick={handleQuit}>Quit</FormButton>
                <FormButton primary  onClick={handleCreateRequest}>Update</FormButton>
                
              </FormButtonsWrap>
              {isSubmitting && <LoaderWrap><Ring color={'#001235'} size='2' sizeUnit='rem' /></LoaderWrap>}
            </span>
          </div>
          <div style={{width:'100%', float:'left', border:'0px solid'}}>&nbsp;</div>
          
          <div style={{width:'100%', float:'left', border:'0px solid'}}>
            <span style={{float:'left', width:'10%'}}>&nbsp;</span>
            <span style={{float:'left', width:'60%'}}>
            {submitErrors.length > 0 && submitErrors.map(err => {
              return (
                <ErrorsBlock key={Math.random()}>
                  <IconWrap>!</IconWrap>
                  {err}
                </ErrorsBlock>
              );
            })}
            </span>
          </div>
        </div>
      </Fragment>
         
    </div>
  );
};

const mapStateToProps = state => {
  return {
    account: state.account
  };
};

export default connect(
  mapStateToProps,
  { pushMessage }
)(UpdateEffectiveDate);

document.addEventListener('click', function(e) {
  e = e || window.event;
  var target = e.target;
  var clickedTargetID = target.id;
  console.log(clickedTargetID);
  if(clickedTargetID != '' && !clickedTargetID.includes("react-select"))
  {
    var exp_1 = clickedTargetID.split("_");
    if(exp_1[0] != 'frmAssigneeLI' && document.getElementById('searchResult')) //R2 - w3: To fix blank sccreen error onlcick of any input
    {
      document.getElementById('searchResult').innerHTML = '&nbsp;';
      document.getElementById('searchResult').style.display = 'none';
    }
  }
  else
  {
    if(document.getElementById('searchResult'))
    {
      document.getElementById('searchResult').innerHTML = '&nbsp;';
      document.getElementById('searchResult').style.display = 'none';
    }
  }
  
}, false);